import React from 'react';
import Footer from './Footer';

const faqs = [
  {
    question: 'How should I prepare for my tattoo appointment?',
    answer: 'Get a good night’s sleep, eat a meal beforehand, stay hydrated, and avoid alcohol or blood thinners.'
  },
  {
    question: 'Does getting a tattoo hurt?',
    answer: 'Pain levels vary by person and placement, but most people describe it as a tolerable scratching or burning sensation.'
  },
  {
    question: 'How do I care for my new tattoo?',
    answer: 'Keep it clean, moisturized, and avoid direct sunlight or soaking in water for at least two weeks.'
  },
  {
    question: 'Can I bring a friend to my appointment?',
    answer: 'Most studios allow one guest, but check with your artist or studio for their specific policy.'
  },
  {
    question: 'How long does a tattoo take to heal?',
    answer: 'Initial healing takes 2-3 weeks, but full healing can take up to 2 months.'
  },
  {
    question: 'What should I do if my tattoo gets infected?',
    answer: 'Contact your artist or a healthcare professional if you notice signs of infection such as redness, swelling, or pus.'
  }
];

const FAQ: React.FC = () => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Frequently Asked Questions</h1>
      <div>
        {faqs.map((faq, idx) => (
          <div key={idx} style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>{faq.question}</h2>
            <p style={{ margin: 0 }}>{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
    <Footer />
  </div>
);

export default FAQ; 